import request from "../utils/request"
export function list(data) {//渠道选项
    return request({
        url:'/service/mg/follower/list',
        method:'post',
        data
    })
}
export function getInvoiceList(data) {//渠道选项
    return request({
        url:'/service/mg/follower/list',
        method:'post',
        data
    })
}
/**
 * 客户信息
 */
export function getCustomer(id) {
    return request({
        // url: "/service/mg/follower/user/buyerId",
        url: "/service/mg/point/query-buyer-balance",
        method: "post",
        data: {
            buyerId: id,
        },
    });
}
/**
 * 可操作积分项
 */
export function getPointItem(data={}) {
    return request({
        url: "/service/mg/point/item-list",
        method: "post",
        data: data,
    });
}
/**
 * 积分变更提交
 */
export function savePointSubmit(data) {
    return request({
        url: "/service/mg/point/submit",
        method: "post",
        data:data,
    });
}